module.exports = __webpack_public_path__ + "img/icon-copy.8db1c81c.svg";